import axios, { AxiosResponse } from 'axios';
import buildQueryOpts from '@/shared/filter/filtering';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IVerificacion, Verificacion } from '@/shared/model/seguimiento/verificacion/verificacion.model';
import { DetalleVerificacion, IDetalleVerificacion } from '@/shared/model/seguimiento/verificacion/detalleVerificacion.model';

const baseApiUrl = 'api/verificaciones';

export default class VerificacionService {
  public obtenerVerificaciones(paginationQuery?: any): Promise<AxiosResponse<Array<IVerificacion>>> {
    return new Promise<AxiosResponse<Array<IVerificacion>>>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}${buildQueryOpts(paginationQuery.filter)}`)
        .then(res => {
          if (res?.data?.length > 0) {
            const verificaciones = res.data.map(verificacion => Verificacion.fromObject(verificacion));
            res.data = verificaciones;
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public obtenerVerificacionBecarios(id: string, filter: any, paginationQuery?: any): Promise<AxiosResponse<Array<IDetalleVerificacion>>> {
    return new Promise<AxiosResponse<Array<IDetalleVerificacion>>>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}/becarios?${buildPaginationQueryOpts(paginationQuery)}${buildQueryOpts(filter)}`)
        .then(res => {
          if (res?.data?.length > 0) {
            const verificaciones = res.data.map(verificacion => DetalleVerificacion.fromObject(verificacion));
            res.data = verificaciones;
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public verificarBecariosActivos(verificacionId: string, filter: any, becaIds: Array<string> = []): Promise<IVerificacion> {
    return new Promise<IVerificacion>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${verificacionId}/activos?${buildQueryOpts(filter)}`, becaIds)
        .then(res => {
          resolve(Verificacion.fromObject(res.data));
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public verificarBecariosInactivos(
    verificacionId: string,
    tipoMovimientoClave: string,
    filter: any,
    becaIds: Array<string> = []
  ): Promise<IVerificacion> {
    return new Promise<IVerificacion>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${verificacionId}/inactivos/${tipoMovimientoClave}?${buildQueryOpts(filter)}`, becaIds)
        .then(res => {
          resolve(Verificacion.fromObject(res.data));
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public verificaBecariosInactivos(verificacionId: string, filter: any, becaIds: Array<string> = []): Promise<IVerificacion> {
    return new Promise<IVerificacion>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${verificacionId}/inactivos?${buildQueryOpts(filter)}`, becaIds)
        .then(res => {
          resolve(Verificacion.fromObject(res.data));
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
